import has from 'lodash/has';
import replace from 'lodash/replace';
import { getCurrentUtcTime } from '../lib/DateUtils';

import trim from 'lodash/trim';
import trimEnd from 'lodash/trimEnd';
import endsWith from 'lodash/endsWith';
import isEmpty from 'lodash/isEmpty';
const responseType = 'token';

// class ZendeskService {
function authenticate(fn, options = {}) {
  const coreClientId = options['zendesk.core.client_id'];
  const chatClientId = options['zendesk.chat.client_id'];
  let isChatAPI =
    has(options, 'zendesk.api_type') && options['zendesk.api_type'] === 'Zendesk Chat API'
      ? true
      : false;

  let clientId = isChatAPI ? chatClientId : coreClientId;

  let scope = has(options, 'zendesk.auth_scope') ? options['zendesk.auth_scope'] : 'read';

  let subdomain = has(options, 'zendesk.subdomain')
    ? trim(options['zendesk.subdomain'])
    : 'nexla.zendesk.com';
  subdomain = replace(subdomain, /^(https:\/\/|http:\/\/)/, '');
  subdomain = endsWith(subdomain, '/') ? trimEnd(subdomain, '/') : subdomain;

  let params = [];
  params.push(`response_type=${responseType}`);
  params.push(`client_id=${clientId}`);
  // params.push(`client_secret=${clientSecret}`);
  params.push(`scope=${encodeURIComponent(scope)}`);

  let oAuthURLDomain = `https://${subdomain}/oauth/authorizations/new`;
  let subdomainParam = subdomain;

  if (endsWith(subdomain, '.zendesk.com')) {
    if (isChatAPI) {
      oAuthURLDomain = 'https://www.zopim.com/oauth2/authorizations/new';
      subdomainParam = replace(subdomain, /(\.zendesk.com)$/, '');
      if (!isEmpty(subdomainParam)) {
        params.push(`subdomain=${subdomainParam}`);
      }
    }
  } else {
    if (isChatAPI) {
      oAuthURLDomain = 'https://www.zopim.com/oauth2/authorizations/new';
      if (!isEmpty(subdomainParam)) {
        params.push(`subdomain=${subdomainParam}`);
      }
    } else {
      oAuthURLDomain = `https://${subdomain}.zendesk.com/oauth/authorizations/new`;
    }
  }

  let redirectUri = `${window.location.protocol}//${window.location.host}/zendeskAuth`;
  params.push(`redirect_uri=${encodeURIComponent(redirectUri)}`);

  window.HandlePopupResult = function (responseJSON, error) {
    let accessToken = null;
    let accessError = null;
    if (error) {
      accessError = error;
    } else {
      if (has(responseJSON, 'access_token')) {
        accessToken = responseJSON.access_token;
      } else if (has(responseJSON, 'error')) {
        accessError = {
          code: responseJSON.error,
          description: has(responseJSON, 'error_description')
            ? responseJSON.error_description
            : responseJSON.error,
        };
      }
    }
    if (accessToken) {
      fn({ ...responseJSON, accessToken, authorizedAt: getCurrentUtcTime() }, null);
    } else {
      fn(null, accessError);
    }

    delete window.HandlePopupResult;
  };

  let oauthUrl = `${oAuthURLDomain}?${params.join('&')}`;
  window.open(oauthUrl, 'Zendesk Authorization', 'top=300,left=250,height=600,width=600');
}
// }

export default {
  authenticate,
};
